module.exports = __webpack_public_path__ + "com_index_03bg.jpg?9aa9c59954b98e1bc144d7801f121e09";


//////////////////
// WEBPACK FOOTER
// ./static/images/com_index_03bg.jpg
// module id = 308
// module chunks = 0